import {Component, OnInit} from '@angular/core';
import {MobileInsuranceService} from '../../../services/mobile-insurance.service';
import {Option, Response, StaticMethods} from '../../../model/GeneralModels';
import {FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {AuthService} from '../../../services/auth.service';

@Component({
  selector: 'app-mobile-offer',
  templateUrl: './mobile-offer.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ],
  styles: [`

    .shadow {
      box-shadow: 3px 3px 5px grey;
    }
  `]
})
export class MobileOfferComponent implements OnInit {
  formsData: any = {};
  offers = [];
  groupForm = this.fb.group({
    offerID: ['', Validators.required]
  });
  translation: any = {};
  viewList: any = {};

  constructor(
    private services: MobileInsuranceService,
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    public settings: AppSettingsService
  ) {
  }

  ngOnInit() {
    if (StaticMethods.checkState(this.router, ['formsData', 'translation', 'viewList'], '/mobile/basic-information')) {
      this.formsData = history.state.formsData;
      this.translation = history.state.translation;
      this.viewList = history.state.viewList;
      console.log(this.formsData);
      this.services.getOffers(this.formsData.franchiseID, this.formsData.price, this.formsData.typeID, this.formsData.brandID,
        this.formsData.model, this.formsData.companyName).subscribe((response: Response) => {
        console.log(response);
        if (response.success) {
          this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
          console.log(response);
          this.offers = [];
          response.data.forEach(offer => {
            const index = this.offers.length;
            this.offers[index] = {
              id: offer.id,
              percent: offer.percent,
              companyName: offer.companyName,
              price: StaticMethods.numberWithCommas(offer.price),
              originalPrice: StaticMethods.numberWithCommas(offer.originalPrice),
              duration: this.settings.translateEnglish(offer.duration, this.translation),
              servicesSet: [],
              discountsList: offer.discountsList
            };
            offer.services.forEach(service => {
              this.offers[index].servicesSet[this.offers[index].servicesSet.length] = service.persianLabel;
            });
          });
          console.log(this.offers);
        } else {
          this.goBack();
        }
      });
    }
  }

  onSelectionChange(offer: any) {
    console.log(offer);
    this.groupForm.controls.offerID.patchValue(offer.id);
    this.changeSelectedPanel(offer.id);
  }

  changeSelectedPanel(offerID) {
    let element;
    if (this.groupForm.controls.offerID.valid) {
      element = document.getElementById(this.groupForm.controls.offerID.value + '');
      element.style.display = 'none';
    }
    element = document.getElementById(offerID + '');
    element.style.display = 'block';
    this.groupForm.controls.offerID.patchValue(offerID);
  }

  submit() {
    if (this.groupForm.controls.offerID.value) {
      this.formsData.offerID = this.groupForm.controls.offerID.value;
      this.services.checkInfo(this.formsData).subscribe((response: Response) => {
        if (response.success) {
          this.router.navigate(['/mobile/confirmation'], {
            state: {
              formsData: this.formsData,
              viewList: response.data,
              translation: this.translation
            }
          });
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['/mobile/basic-information'], {state: history.state});
  }
}
